import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { STIRPE_PUBLIC_KEY } from "../constant/common";
import Spinner from "../components/common/Spinner";

const StripeLoader = ({ children }) => {
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const loadStripeKey = async () => {
      const stripe = await loadStripe(STIRPE_PUBLIC_KEY);
      setStripePromise(stripe);
    };

    loadStripeKey();
  }, []);

  if (!stripePromise) {
    return <Spinner adminLayout={true} />; 
  }

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeLoader;
